import { DomSanitizer } from '@angular/platform-browser';
import { ElementRef } from '@angular/core';
import {ServiceNotificationService} from "../services/service-notification.service";
import {promises} from "node:dns";
import {error} from "@angular/compiler-cli/src/transformers/util";
declare var bootstrap: any;



export class ValidateCedula {

  constructor( private serviceNotification: ServiceNotificationService
  ) {
  }
  static validarCedula(cedula: string): boolean {
    // Preguntamos si la cédula consta de 10 dígitos
    if (cedula.length === 10) {
      // Obtenemos el dígito de la región que son los dos primeros dígitos
      const digito_region = parseInt(cedula.substring(0, 2), 10);

      // Pregunto si la región existe (Ecuador se divide en 24 regiones)
      if (digito_region >= 1 && digito_region <= 24) {
        // Extraigo el último dígito
        const ultimo_digito = parseInt(cedula.substring(9, 10), 10);

        // Agrupo todos los pares y los sumo
        const pares =
          parseInt(cedula.substring(1, 2), 10) +
          parseInt(cedula.substring(3, 4), 10) +
          parseInt(cedula.substring(5, 6), 10) +
          parseInt(cedula.substring(7, 8), 10);

        // Agrupo los impares, los multiplico por un factor de 2, si la resultante es > que 9 le restamos el 9 a la resultante
        const obtenerNumeroImpar = (numero: string): number => {
          let resultado = parseInt(numero, 10) * 2;
          if (resultado > 9) {
            resultado -= 9;
          }
          return resultado;
        };

        const impares =
          obtenerNumeroImpar(cedula.substring(0, 1)) +
          obtenerNumeroImpar(cedula.substring(2, 3)) +
          obtenerNumeroImpar(cedula.substring(4, 5)) +
          obtenerNumeroImpar(cedula.substring(6, 7)) +
          obtenerNumeroImpar(cedula.substring(8, 9));

        // Suma total
        const suma_total = pares + impares;

        // Extraemos el primer dígito
        const primer_digito_suma = parseInt(suma_total.toString().substring(0, 1), 10);

        // Obtenemos la decena inmediata
        const decena = (primer_digito_suma + 1) * 10;

        // Obtenemos la resta de la decena inmediata - la suma_total esto nos da el dígito validador
        let digito_validador = decena - suma_total;

        // Si el dígito validador es = a 10 toma el valor de 0
        if (digito_validador === 10) {
          digito_validador = 0;
        }

        // Validamos que el dígito validador sea igual al de la cédula
        if (digito_validador === ultimo_digito) {
          console.log(`El número de cédula ${cedula} es válido`);
          return true;
        } else {
          console.log(`El número de cédula ${cedula} no es válido`);
          return false;
        }
      } else {
        // Imprimimos en consola si la región no pertenece
        console.log(`El número de cédula ${cedula} no pertenece a ninguna región`);
        return false;
      }
    } else {
      // Imprimimos en consola si la cédula tiene más o menos de 10 dígitos
      console.log(`El número de cédula ${cedula} tiene solo ${cedula.length} dígitos`);
      return false;
    }
  }






}
export function mostrarToast(message: string, type: boolean, serviceNotification: ServiceNotificationService) {
  serviceNotification.recibeNotificacion.emit({
    mensaje: message,
    tipo: type
  })
}

export function convertirPrimeraLetraMayuscula(texto: any) {
  return texto.toLowerCase().split(' ').map((word: string) => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');

}


export function decodeBase64(base64: string) {
  let decode;
  try{
    decode = atob(base64)
    return getCodeAfterDot(decode);

  }catch (error ){
  // console.error(error)
    return false;
  }
}


export function getCodeAfterDot(decodedString: string): string {
  const parts = decodedString.split('.');
  if (parts.length > 1) {
    return parts[1]; // Retorna el código después del punto
  }
  // console.warn("No se encontró un punto en el string.");
  return '';
}







export function saltosDeLinea(texto: string) {
  return texto.replace(/\n/g, '<br>');
}


export function capturarFile(event: Event, sanitizer: DomSanitizer, archivos: File[], setPreview: (preview: string | ArrayBuffer | null) => void): void {
  const input = event.target as HTMLInputElement;
  if (input && input.files) {
    const file = input.files[0];
    extraerBase64(file, sanitizer).then((imagen: any) => {
      setPreview(imagen.base);
    });
    archivos.push(file);
  } else {
    console.error('No files selected or input is null');
  }
}

// Función para extraer Base64 de un archivo
export function extraerBase64(file: File, sanitizer: DomSanitizer): Promise<{ base: string | ArrayBuffer | null }> {
  return new Promise((resolve, reject) => {
    try {
      const unsafeImg = window.URL.createObjectURL(file);
      const image = sanitizer.bypassSecurityTrustUrl(unsafeImg);
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        resolve({
          base: reader.result
        });
      };
      reader.onerror = error => {
        resolve({
          base: null
        });
      };
    } catch (e) {
      reject(e);
    }
  });
}

export function validateSizeFile(fileSize: number): boolean {
  const size: number=   5 * 1024 * 1024
  return fileSize <= size;
}




export function closeModal(modalElement: ElementRef) {
  const modal = bootstrap.Modal.getInstance(modalElement.nativeElement);
  if (modal) {
    modal.hide();
  }
}

export function openModal(modalElement: ElementRef) {
  const modal = bootstrap.Modal.getInstance(modalElement.nativeElement);
  if (modal) {
    modal.show();
  }else {
    console.log("No se pudo abrir")
  }
}




